package org.matthewo.api

fun Int.gameMeta() = when (this) {
    2026 -> MetricsBioBuzzMeta
    2025 -> MetricsDecodeMeta
    102024 -> MetricsIntoTheDeepCRIMeta
    2024 -> MetricsIntoTheDeepMeta
    102023 -> MetricsCenterStageCRIMeta
    2023 -> MetricsCenterStageMeta
    102022 -> MetricsPowerPlayCRIMeta
    2022 -> MetricsPowerPlayMeta
    102021 -> MetricsFreightFrenzyCRIMeta
    2021 -> MetricsFreightFrenzyMeta
    else -> null
}
